import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, HostBinding, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from 'se-fe-header';
import { SeFeHeaderModule } from 'se-fe-header';

class SeFeCardComponent {
    constructor() {
        this.themeReset = true;
        this.baseClass = true;
        this.seFeDataFullHeight = false;
    }
}
SeFeCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeCardComponent, selector: "se-fe-card", inputs: { seFeDataFullHeight: "seFeDataFullHeight" }, host: { properties: { "class.se-fe-theme--reset": "this.themeReset", "class.se-fe-card": "this.baseClass", "class.se-fe-card--full-height": "this.seFeDataFullHeight" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".se-fe-card{background:var(--se-bg);border-radius:4px;box-shadow:var(--se-raised-shadow);box-sizing:border-box;display:flex;flex-direction:column;font:var(--se-body-font);color:var(--se-text);padding:.05px 0;width:100%}.se-fe-card--full-height{height:100%}.se-fe-card--full-height>*{flex:1 1 auto}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-card',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-card.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { themeReset: [{
                type: HostBinding,
                args: ['class.se-fe-theme--reset']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-card']
            }], seFeDataFullHeight: [{
                type: HostBinding,
                args: ['class.se-fe-card--full-height']
            }, {
                type: Input
            }] } });

class SeFeCardContentComponent {
    constructor() {
        this.seFeDataFullHeight = false;
    }
}
SeFeCardContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeCardContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeCardContentComponent, selector: "se-fe-card-content", inputs: { seFeDataFullHeight: "seFeDataFullHeight" }, host: { properties: { "class.se-fe-card-content--full-height": "this.seFeDataFullHeight" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:block;padding:var(--se-container-spacing-mobile)}:host:not(:first-child){padding-top:.05px}@media (min-width: 600px){:host{padding:var(--se-container-spacing)}}:host.se-fe-card-content--full-height{flex:1 1 100%;overflow-x:hidden;overflow-y:auto}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-card-content',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-card-content.component.scss'],
                }]
        }], propDecorators: { seFeDataFullHeight: [{
                type: HostBinding,
                args: ['class.se-fe-card-content--full-height']
            }, {
                type: Input
            }] } });

class SeFeCardFooterComponent {
    constructor() {
        this.baseClass = true;
        this.border = false;
        this.borderFull = false;
    }
    set seFeDataBorder(border) {
        this.border = !!border;
        this.borderFull = border === 'full';
    }
}
SeFeCardFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeCardFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeCardFooterComponent, selector: "se-fe-card-footer", inputs: { border: "border", borderFull: "borderFull", seFeDataBorder: "seFeDataBorder" }, host: { properties: { "class.se-fe-card-footer": "this.baseClass", "class.se-fe-card-footer--border": "this.border", "class.se-fe-card-footer--border-full": "this.borderFull" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host.se-fe-card-footer--border:not(:first-child):before{background:var(--se-divider);height:1px}:host{display:block;padding:var(--se-container-spacing);padding-left:var(--se-container-spacing-mobile)}@media (min-width: 600px){:host{padding:var(--se-container-spacing)}}:host:not(:first-child){padding-top:0}:host.se-fe-card-footer--border:not(:first-child):before{content:\"\";display:block;margin-bottom:var(--se-container-spacing)}:host.se-fe-card-footer--border-full:before{margin:0 0-var(--se-container-spacing-mobile)}@media (min-width: 600px){:host.se-fe-card-footer--border-full:before{margin:0 0-var(--se-container-spacing)}}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-card-footer',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-card-footer.component.scss'],
                }]
        }], propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-card-footer']
            }], border: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.se-fe-card-footer--border']
            }], borderFull: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.se-fe-card-footer--border-full']
            }], seFeDataBorder: [{
                type: Input,
                args: ['seFeDataBorder']
            }] } });

class SeFeCardHeaderComponent {
    set seFeDataTitle(title) {
        this.title = title;
    }
    set seFeDataSubtitle(subtitle) {
        this.subtitle = subtitle;
    }
    set seFeDataHeavyBorder(border) {
        this.border = border;
    }
    set seFeDataBorder(border) {
        this.border = border;
    }
}
SeFeCardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeCardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeCardHeaderComponent, selector: "se-fe-card-header", inputs: { title: "title", seFeDataTitle: "seFeDataTitle", subtitle: "subtitle", seFeDataSubtitle: "seFeDataSubtitle", border: "border", seFeDataHeavyBorder: "seFeDataHeavyBorder", seFeDataBorder: "seFeDataBorder" }, host: { properties: { "class.se-fe-card-header--border": "this.border" } }, ngImport: i0, template: "<se-fe-header\n  [seFeDataTitle]=\"title\"\n  [seFeDataSubtitle]=\"subtitle\"\n  seFeDataSize=\"700\">\n  <ng-content seFeHeaderVisual select=\"[seFeCardHeaderVisual]\"></ng-content>\n  <ng-content seFeHeaderTitle select=\"[seFeCardHeaderTitle]\"></ng-content>\n  <ng-content seFeHeaderTitleExtra select=\"[seFeCardHeaderTitleExtra]\"></ng-content>\n  <ng-content seFeHeaderSubtitle select=\"[seFeCardHeaderSubtitle]\"></ng-content>\n  <ng-content seFeHeaderActions select=\"[seFeCardHeaderActions]\"></ng-content>\n</se-fe-header>\n", styles: [":host.se-fe-card-header--border:not(:last-child):after{background:var(--se-divider);height:1px}:host{display:block;margin-bottom:var(--se-container-spacing-mobile);padding:var(--se-container-spacing-mobile) var(--se-container-spacing-mobile) 0}@media (min-width: 600px){:host{margin-bottom:var(--se-container-spacing);padding:var(--se-container-spacing) var(--se-container-spacing) 0}}:host:after{content:\"\";display:block;height:0}:host:not(:last-child){padding-bottom:0}:host.se-fe-card-header--border:not(:last-child):after{margin:var(--se-container-spacing-mobile) 0-var(--se-container-spacing-mobile) 0}@media (min-width: 600px){:host.se-fe-card-header--border:not(:last-child):after{margin:var(--se-container-spacing-mobile) calc(var(--se-container-spacing) * -.5) 0}}\n"], components: [{ type: i1.SeFeHeaderComponent, selector: "se-fe-header", inputs: ["titleText", "seFeDataTitle", "subtitleText", "seFeDataSubtitle", "size", "seFeDataSize", "_level", "seFeDataLevel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-card-header',
                    templateUrl: './se-fe-card-header.component.html',
                    styleUrls: ['./se-fe-card-header.component.scss'],
                }]
        }], propDecorators: { title: [{
                type: Input
            }], seFeDataTitle: [{
                type: Input,
                args: ['seFeDataTitle']
            }], subtitle: [{
                type: Input
            }], seFeDataSubtitle: [{
                type: Input,
                args: ['seFeDataSubtitle']
            }], border: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.se-fe-card-header--border']
            }], seFeDataHeavyBorder: [{
                type: Input,
                args: ['seFeDataHeavyBorder']
            }], seFeDataBorder: [{
                type: Input,
                args: ['seFeDataBorder']
            }] } });

class SeFeCardModule {
}
SeFeCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardModule, declarations: [SeFeCardComponent,
        SeFeCardContentComponent,
        SeFeCardFooterComponent,
        SeFeCardHeaderComponent], imports: [CommonModule,
        SeFeHeaderModule], exports: [SeFeCardComponent,
        SeFeCardContentComponent,
        SeFeCardFooterComponent,
        SeFeCardHeaderComponent] });
SeFeCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardModule, imports: [[
            CommonModule,
            SeFeHeaderModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SeFeHeaderModule,
                    ],
                    declarations: [
                        SeFeCardComponent,
                        SeFeCardContentComponent,
                        SeFeCardFooterComponent,
                        SeFeCardHeaderComponent,
                    ],
                    exports: [
                        SeFeCardComponent,
                        SeFeCardContentComponent,
                        SeFeCardFooterComponent,
                        SeFeCardHeaderComponent,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeCardComponent, SeFeCardContentComponent, SeFeCardFooterComponent, SeFeCardHeaderComponent, SeFeCardModule };
